var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play-area overflow-hidden"},[_c('resize-observer',{on:{"notify":_vm.resizeListener}}),_c('div',{staticClass:"gamecanvas"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }